function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.333 2.5H1.667M17.5 2.5v9.902c0 .975-.84 1.765-1.875 1.765H4.375c-1.036 0-1.875-.79-1.875-1.765V2.5M10.833 14.166L12.5 17.5M9.167 14.166L7.5 17.5",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.333 6.667l-2.777 2.777-1.667-1.667L6.667 10",
  stroke: "#000",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));